import { Copy } from 'lucide-react';
import { useState } from 'react';
import { useConfig } from '@/shared/utils/config/config-context';

function VersionTag({ children, className, onClick }: { children: React.ReactNode; className?: string; onClick?: () => void }) {
    const sharedClassName =
        'inline-flex items-center gap-1 border px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-[0.1em] shadow-sm backdrop-blur transition';

    if (onClick) {
        return (
            <button type="button" className={`${sharedClassName} ${className ?? ''}`} onClick={onClick}>
                {children}
            </button>
        );
    }

    return <div className={`${sharedClassName} ${className ?? ''}`}>{children}</div>;
}

export function AppVersionTag() {
    const { config } = useConfig();
    const [copiedVersion, setCopiedVersion] = useState(false);
    const environment = (config?.ENVIRONMENT_NAME ?? 'local').replaceAll('_', ' ');
    const householdVersion = config?.HOUSEHOLD_VERSION;

    const handleCopyVersion = async () => {
        if (!householdVersion) {
            return;
        }

        try {
            await navigator.clipboard.writeText(householdVersion);
            setCopiedVersion(true);
            window.setTimeout(() => setCopiedVersion(false), 1500);
        } catch (error) {
            console.warn('Failed to copy version to clipboard', error);
        }
    };

    return (
        <div className="fixed bottom-0 right-0 z-[9999] flex items-end opacity-95">
            <VersionTag className="border-[#16384A] bg-[#0B2433] text-[#B8C8D2]">{environment}</VersionTag>
            {householdVersion ? (
                <VersionTag className="border-[#1F4D35] bg-[#012A3C] text-[#91FF03] hover:bg-[#0A3348]" onClick={handleCopyVersion}>
                    <strong>ver. {householdVersion}</strong>
                    <Copy className="h-2.5 w-2.5" />
                    <span className="sr-only">{copiedVersion ? 'Version copied' : 'Copy version'}</span>
                </VersionTag>
            ) : null}
        </div>
    );
}
